import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KeyboardServiceService } from '../keyboard-service/keyboard-service.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss']
})
export class KeyboardComponent {
  uppercase: boolean = false;
  lowercase: boolean = true;
  order: number = 1;

  @Output() displayValue: EventEmitter<any> = new EventEmitter();
  @Input() next: boolean;
  @Input() email: boolean;
  
  constructor(private keyboard: KeyboardServiceService) {
  }

  private emitValue(val) {
    this.displayValue.emit(val);    
  }

  isNumberPad () {
    return this.keyboard.isNumberPad;
  }

  isKeyPad () {
    return !this.keyboard.isNumberPad;
  }

  isNext() {
    return this.next;
  }

  isEmail() {
    return this.email;
  }

  toggleShift() {
    if (this.lowercase) {
      this.lowercase = false;
      this.uppercase = true;
    } else {
      this.lowercase = true;
      this.uppercase = false;
    }
  }

  onKeyPress(keyValue:string, $event: Event){
    this.emitValue(keyValue);
    this.lowercase = true;
    this.uppercase = false;
  }

  onKeyTapPress(keyValue:string){
    this.emitValue(keyValue);
    this.lowercase = true;
    this.uppercase = false;
  }

  onDelete(){
    this.emitValue('DELETE');
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/keyboard/keyboard.component.ts